module.exports = __webpack_public_path__ + "static/media/2.7e5c5dc2.jpeg";